import {} from "../types";

const UserReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "GET_USERS":
      return {
        ...state,
        users: payload,
        loading: false,
      };
    case "GET_USER":
      return {
        ...state,
        user: payload,
      };
    case "UPDATE_USER":
      return {
        ...state,
        users: state.users.map((user) =>
          user._id === action.payload._id ? action.payload : user
        ),
      };
    case "DELETE_USER":
      return {
        ...state,
        users: state.users.filter((user) => user._id !== payload),
      };
    case "FILTER_PERMISSION_TABLE":
      let asc = state.permissionsSortOptions[payload].asc === false;
      let normal = state.permissionsSortOptions[payload].desc === true;
      return {
        ...state,
        users: normal
          ? state.users.sort((a, b) => (a["name"] < b["name"] ? 1 : -1))
          : asc
          ? state.users.sort((a, b) => (a[payload] > b[payload] ? 1 : -1))
          : state.users.sort((a, b) => (a[payload] < b[payload] ? 1 : -1)),
        permissionsSortOptions: {
          ...{
            name: { asc: false, desc: false },
            status: { asc: false, desc: false },
            charterAssignments: { asc: false, desc: false },
            action: { asc: false, desc: false },
          },
          [payload]: normal
            ? { asc: false, desc: false }
            : asc
            ? { asc: true, desc: false }
            : { asc: false, desc: true },
        },
      };
    case "SEARCH_FILTER":
      return {
        ...state,
        filteredUsers: state.users.filter((item) => {
          const regex = new RegExp(`${payload}`, "gi");
          return item.name.match(regex) || item.userStatus.match(regex);
        }),
      };
    case "CLEAR_SEARCH_FILTER":
      return {
        ...state,
        filteredUsers: [],
      };
    case "SET_FORM_MODAL":
      return {
        ...state,
        formModal: {
          ...state.formModal,
          [payload.name]: payload.value,
        },
      };
    case "GET_SQL_USERS":
      return {
        ...state,
        sqlUserResults: payload,
      };
    case "CLEAR_SQL_USER_RESULTS":
      return {
        ...state,
        sqlUserResults: [],
      };
    case "GET_CHARTERS":
      return {
        ...state,
        charters: payload,
      };
    case "FILTER_CHARTERS":
      return {
        ...state,
        filteredCharters: state.charters.filter((item) => {
          const regex = new RegExp(`${payload}`, "gi");
          return item.name.match(regex) || item.abbreviation.match(regex);
        }),
      };
    case "CLEAR_FILTER_CHARTERS":
      return {
        ...state,
        filteredCharters: [],
      };
    case "CREATE_NEW_PERMISSION":
      return {
        ...state,
        users: [...state.users, payload],
      };
       case "GET_PROGRAMTYPES":
      return {
        ...state,
        programTypes: payload,
      };
    default:
      return state;
  }
};

export default UserReducer;
